/**
 * @generated SignedSource<<196781cbcc8dee42392b8f223ef63183>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PackageDateRow_data$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PackageDateRowFlight_data">;
  readonly " $fragmentType": "PackageDateRow_data";
};
export type PackageDateRow_data$key = {
  readonly " $data"?: PackageDateRow_data$data;
  readonly " $fragmentSpreads": FragmentRefs<"PackageDateRow_data">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PackageDateRow_data",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PackageDateRowFlight_data"
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "ef2461781ce99501566641bc248e6a7c";

export default node;
